/* AVN Product Experience — isolated Horizon / Shopify AJAX controller. */
(() => {
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
    style: 'currency', currency: currency || window.Shopify?.currency?.active || 'GBP'
  }).format((cents || 0) / 100);
  const escapeHtml = (str) => String(str ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const rootPath = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function init(section) {
    if (section.dataset.avnReady === 'true') return;
    section.dataset.avnReady = 'true';
    const q = selector => section.querySelector(selector);
    const qa = selector => Array.from(section.querySelectorAll(selector));
    const json = el => { try { return JSON.parse(el?.textContent || 'null'); } catch { return null; } };
    const variants = json(q('[data-avn-variants]')) || [];
    const currentProduct = json(q('[data-avn-current-product]'));
    const form = q('[data-avn-form]');
    const variantIdInput = q('[data-avn-variant-id]');
    const addBtn = q('[data-avn-add]');
    const error = q('[data-avn-error]');
    const hero = q('[data-avn-hero]');
    const drawer = q('[data-avn-drawer]');
    const shade = q('[data-avn-shade]');
    const lightbox = q('[data-avn-lightbox]');
    const thumbs = qa('[data-avn-thumb]');
    const thumbClick = (thumb) => {
      if (!hero) return;
      hero.src = thumb.dataset.fullUrl;
      hero.alt = thumb.dataset.imageAlt || '';
      thumbs.forEach(t => t.classList.toggle('is-active', t === thumb));
      const idx = thumbs.indexOf(thumb);
      if (q('[data-avn-counter]')) q('[data-avn-counter]').textContent = `${String(idx + 1).padStart(2, '0')} / ${String(thumbs.length).padStart(2, '0')}`;
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => thumbClick(thumb)));
    if (hero && thumbs.length && !thumbs.some(t => t.classList.contains('is-active'))) thumbs[0].classList.add('is-active');

    q('[data-avn-zoom]')?.addEventListener('click', () => {
      if (!hero || !lightbox) return;
      q('[data-avn-lightbox-image]').src = hero.src;
      lightbox.classList.add('is-open');
    });
    q('[data-avn-lightbox-close]')?.addEventListener('click', () => lightbox.classList.remove('is-open'));
    lightbox?.addEventListener('click', event => { if (event.target === lightbox) lightbox.classList.remove('is-open'); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') { closeCart(); lightbox?.classList.remove('is-open'); }
    });

    function selectVariant() {
      const groups = qa('[data-avn-option-index]');
      const chosen = groups.map(group => {
        const checked = group.querySelector('input:checked');
        if (q('[data-avn-chosen]')) {/* noop: label is per group */}
        const value = checked?.value || '';
        const label = group.querySelector('[data-avn-chosen]');
        if (label) label.textContent = value;
        return value;
      });
      const variant = groups.length
        ? variants.find(v => v.options.every((val, i) => val === chosen[i]))
        : variants.find(v => String(v.id) === variantIdInput.value) || variants[0];
      if (!variant) {
        addBtn.disabled = true;
        addBtn.textContent = 'Combination unavailable';
        return;
      }
      variantIdInput.value = variant.id;
      const stockLabel = q('[data-avn-stock]');
      if (stockLabel) stockLabel.textContent = !variant.available ? 'Sold out' : stockLabel.dataset.lowStockLabel;
      const available = Boolean(variant.available);
      addBtn.disabled = !available;
      addBtn.textContent = available ? (addBtn.dataset.originalLabel || 'ADD TO BAG') : 'Sold out';
      q('[data-avn-price]').textContent = money(variant.price);
      const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price);
      const compare = q('[data-avn-compare]');
      const separator = q('[data-avn-price-divider]');
      const savings = q('[data-avn-savings]');
      if (compare) { compare.hidden = !hasCompare; compare.textContent = hasCompare ? money(variant.compare_at_price) : ''; }
      if (separator) separator.hidden = !hasCompare;
      if (savings) {
        savings.hidden = !hasCompare;
        if (hasCompare) {
          const difference = variant.compare_at_price - variant.price;
          const percentage = Math.round(difference / variant.compare_at_price * 100);
          savings.innerHTML = `<strong>Save ${percentage}%</strong><span>${money(difference)} off</span>`;
        }
      }
      const activeMediaId = variant.featured_media?.id;
      const matchingThumb = thumbs.find(t => String(t.dataset.mediaId) === String(activeMediaId));
      if (matchingThumb) thumbClick(matchingThumb);
      try { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState(window.history.state, '', url); } catch (_) {}
    }
    addBtn.dataset.originalLabel = addBtn.textContent.trim();
    qa('[data-avn-option-index] input').forEach(input => input.addEventListener('change', selectVariant));

    function openCart() {
      shade?.classList.add('is-open');
      drawer?.classList.add('is-open');
      drawer?.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      shade?.classList.remove('is-open');
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    shade?.addEventListener('click', closeCart);
    q('[data-avn-close]')?.addEventListener('click', closeCart);
    // Cart drawer = theme-wide ML drawer (snippets/ml-cart-drawer.liquid); the AVN panel is only a fallback.
    window.__avnOpenProductCart = async () => {
      if (window.MontleighCart) { await window.MontleighCart.refresh(); window.MontleighCart.open(); return; }
      await renderCart(); openCart();
    };
    q('[data-avn-checkout]')?.addEventListener('click', () => { window.location.href = `${rootPath()}checkout`; });

    function setProgress(count) {
      qa('[data-avn-step]').forEach(el => el.classList.toggle('is-active', Number(el.dataset.avnStep) <= Math.max(count, 1)));
      const message = q('[data-avn-progress-message]');
      if (!message) return;
      if (count >= 4) message.textContent = 'You have reached the highest discount tier';
      else {
        const next = count < 2 ? 2 : count < 3 ? 3 : 4;
        const rate = next === 2 ? 10 : next === 3 ? 15 : 20;
        const needed = next - count;
        message.textContent = `Add ${needed} more item${needed === 1 ? '' : 's'} for ${rate}% off`;
      }
    }
    async function getCart() {
      const response = await fetch(`${rootPath()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Bag unavailable');
      return response.json();
    }
    async function renderCart() {
      const container = q('[data-avn-cart-items]');
      if (!container) return;
      try {
        const cart = await getCart();
        q('[data-avn-count]').textContent = cart.item_count;
        setProgress(cart.item_count);
        q('[data-avn-total]').textContent = money(cart.total_price, cart.currency);
        q('[data-avn-cart-bottom]').hidden = cart.items.length === 0;
        if (!cart.items.length) {
          container.innerHTML = '<div style="text-align:center;margin-top:40%;font-size:15px">Your bag is empty</div>';
          return;
        }
        container.innerHTML = `<p style="font-size:12px">Items</p>` + cart.items.map((item, idx) => `
          <div class="avn-pdp__cart-item">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : ''}
            <div>
              <h4>${escapeHtml(item.product_title || item.title)}</h4>
              <small>${escapeHtml(item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '')}</small>
              <div style="margin:8px 0;font-size:14px">${money(item.final_line_price, cart.currency)}</div>
              <div class="avn-pdp__cart-quantity"><button data-avn-change="${idx}" data-step="-1" aria-label="Eén minder" type="button">−</button>${item.quantity}<button data-avn-change="${idx}" data-step="1" aria-label="Eén meer" type="button">+</button></div>
              <button type="button" class="avn-pdp__remove" data-avn-remove="${idx}">REMOVE</button>
            </div>
          </div>`).join('');
        container.querySelectorAll('[data-avn-change]').forEach(btn => btn.addEventListener('click', () => changeItem(cart.items[Number(btn.dataset.avnChange)], Number(btn.dataset.step))));
        container.querySelectorAll('[data-avn-remove]').forEach(btn => btn.addEventListener('click', () => changeItem(cart.items[Number(btn.dataset.avnRemove)], -cart.items[Number(btn.dataset.avnRemove)].quantity)));
      } catch (err) {
        container.textContent = 'Could not load your bag. Please try again.';
      }
    }
    async function changeItem(item, delta) {
      drawer?.classList.add('avn-pdp__loading');
      try {
        const response = await fetch(`${rootPath()}cart/change.js`, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: Math.max(0, item.quantity + delta) })
        });
        if (!response.ok) throw Error('Aanpassen mislukt');
        await renderCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (_) { await renderCart(); }
      finally { drawer?.classList.remove('avn-pdp__loading'); }
    }
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      if (error) error.hidden = true;
      try {
        const response = await fetch(`${rootPath()}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) { const data = await response.json(); throw new Error(data.description || 'Product kon niet toegevoegd worden'); }
        await window.__avnOpenProductCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      } finally { selectVariant(); }
    });

    const relatedTab = q('[data-avn-tab="related"]');
    const recentTab = q('[data-avn-tab="recent"]');
    const relatedCards = q('[data-avn-cards]');
    const recentCards = q('[data-avn-recent]');
    if (currentProduct && window.localStorage) {
      try {
        const old = JSON.parse(localStorage.getItem('avn_recent_products') || '[]');
        const recent = old.filter(p => p.id !== currentProduct.id).slice(0, 4);
        recentCards.innerHTML = recent.length ? recent.map(p => `<a class="avn-pdp__card" href="${escapeHtml(p.url)}">${p.image ? `<img src="${escapeHtml(p.image)}" loading="lazy" alt="${escapeHtml(p.title)}">` : ''}<h3>${escapeHtml(p.title)}</h3><small>${money(p.price)}</small></a>`).join('') : '<p class="avn-pdp__empty">Je hebt nog geen andere producten bekeken.</p>';
        localStorage.setItem('avn_recent_products', JSON.stringify([currentProduct, ...old.filter(p => p.id !== currentProduct.id)].slice(0, 8)));
      } catch (_) {}
    }
    [relatedTab, recentTab].forEach(btn => btn?.addEventListener('click', () => {
      const isRecent = btn === recentTab;
      relatedTab.classList.toggle('is-selected', !isRecent);
      recentTab.classList.toggle('is-selected', isRecent);
      relatedCards.hidden = isRecent;
      recentCards.hidden = !isRecent;
    }));
  }

  const initialize = () => document.querySelectorAll('[data-avn-product-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
